import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'zc-span',
  templateUrl: './span.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpanComponent {
  constructor() {}
}
